<template>
  <v-container fluid v-if="asyncDataStatus_ready">
    <div class="dashboard-page">
      <v-card width="100%" class="breadcrumbs mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="
              d-sm-flex
              justify-md-start justify-space-between
              align-center
            "
          >
            <h1 class="main-page-title greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Prestação de Contas
            </h1>
            <div class="py-6"></div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end">
            <NovaPrestacaoContas v-if="canCreatePrestacaoConta"></NovaPrestacaoContas>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols="12">
          <v-card width="100%" class="support-table ma-1">
            <v-card-text class="pa-0 overflow-x-auto">
              <v-data-table
                :headers="headers"
                :items="items"
                sort-by="nome"
                no-results-text="Acesso restrito."
                no-data-text="Acesso restrito."
                :items-per-page="itemPerPage"
              >
                <template v-slot:item.data="{ item }">
                  <span class="mb-0 fs-base">{{ formatDate(item.data) }}</span>
                </template>
                <template v-slot:item.nome="{ item }">
                  <span class="mb-0 fs-base">{{ item.nome }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <span v-if="item.status === 'ABERTO'"><v-chip class="ma-2" color="warning">ABERTO</v-chip></span>
                  <span v-if="item.status === 'AGUARDANDO_MONITORAMENTO'"><v-chip class="ma-2" color="primary">AGUARDANDO MONITORAMENTO</v-chip></span>
                  <span v-if="item.status === 'AGUARDANDO_MANIFESTACAO'"><v-chip class="ma-2" color="info">AGUARDANDO MANISFESTAÇÃO</v-chip></span>
                  <span v-if="item.status === 'AGUARDANDO_PARECER'"><v-chip class="ma-2" color="comissaoColor">AGUARDANDO PARECER DA COMISSÃO</v-chip></span>
                  <span v-if="item.status === 'FINALIZADO'"><v-chip class="ma-2" color="success">MONITORAMENTO FINALIZADO</v-chip></span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="text-right">
                    <v-btn @click="pushDetalhesContas(item.projeto.id, item.id)" color="primary" small dark>Detalhes</v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import asyncDataStatus from '@/mixins/asyncDataStatus'
import NovaPrestacaoContas from "./Nova/NovaPrestacaoContas"

export default {
  name: "PrestacaoContas",
  components: {
    NovaPrestacaoContas,
  },
  mixins: [asyncDataStatus],

  data() {
    return {
      headers: [
        { text: "Data", value: "data" },
        { text: "Parceiro", value: "organizacao.nome" },
        { text: "Responsavel", value: "responsavel.nome" },
        { text: "Período da Prestação", value: "periodo" },
        { text: "Status", value: "status" },
        { text: "Parecer", value: "parecer" },
        { text: "", value: "actions", sortable: false },
      ],
      itemPerPage: 5,
    };
  },
  methods: {
    ...mapActions("prestacaoConta", ["fetchPrestacaoContaByProjeto", "deletarOrganizacao"]),

    pushDetalhesContas(projetoId, prestacaoContaId) {
      this.$router.push({ name: 'PrestacaoContaDetalhes', params: { 'projetoId': projetoId, 'prestacaoContaId': prestacaoContaId } })
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },



  },
  computed: {
    items() {
      return this.$store.getters["prestacaoConta/all"];
    },
    canCreatePrestacaoConta() {
      var payload = {
        'papel': 'AGENTE_PRESTACAO_CONTA',
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }
      
      return this.$store.getters["projeto/hasPapel"](payload);
    },


  },

  created() {
    this.fetchPrestacaoContaByProjeto(this.$route.params.projetoId).then(() => { this.asyncDataStatus_fetched() });
  },
};
</script>

<style src="./Contas.scss" lang="scss"/>
